import { classnames } from '@aibees/shared/utils';
import { Box, Typography } from '@mui/material';
import { memo } from 'react';
import * as SX from './sx';
import type { SectionTitleProps as Props } from './types';

export const SectionTitle = memo(({ className, ...filter }: Props) => {
  return (
    <Box
      className={classnames('SectionTitle', className)}
      display="flex"
      alignItems="center"
      sx={SX.root}
    >
      <Typography color="primary" variant="body2" children={filter.name} />
    </Box>
  );
});

SectionTitle.displayName = 'SectionTitle';
